import { Route, Routes } from "react-router-dom";
import EquipmentSetting from "pages/management/setting/basic/equipment";
import EquipmentModifySetting from "pages/management/setting/basic/equipment-modify";
import RouteAccessError from "pages/RouteAccessError";
import PermissionRoute from "components/route/PermissionRoute";
import { PERMISSIONS } from "config/permissions";

export default function MonitoringSettingEquipmentRoutes(props) {

    return (
        <Routes>
            <Route path="/">
                <Route
                    index
                    element={
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_EQUIPMENT_READ}
                        >
                            <EquipmentSetting />
                        </PermissionRoute>
                    }
                />
                <Route path="modify/:id" 
                    element={ 
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_EQUIPMENT_READ}
                        >
                            <EquipmentModifySetting />
                        </PermissionRoute> 
                    }
                 />
                <Route path="add" 
                    element={  
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_EQUIPMENT_WRITE}
                        >
                            <EquipmentModifySetting />
                        </PermissionRoute> 
                    }
                />
                <Route path="*" element={ <RouteAccessError /> }/>
            </Route>
        </Routes>
    );
}